import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';

export default function ConfirmLogoutDialog({ open, onClose, onLogout, onForgetAndLogout }) {
    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>Confirm Logout</DialogTitle>
            <DialogContent>
                <Typography>Do you really want to logout?</Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button onClick={onForgetAndLogout}>Forget Device</Button>
                <Button onClick={onLogout}>Logout</Button>
            </DialogActions>
        </Dialog>
    );
}